export default __webpack_public_path__ + "static/media/user-management-inactive.9a32bf60.svg";